export default {
  // Page title
  'page.title': 'Weltzeituhr',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'Ortszeit',
  'timezone.currentTime': 'Aktuelle Zeit',
  'timezone.label': 'Zeitzone',
  'timezone.title': 'Zeitzone von {{city}}',
  'timezone.localClockOffset': 'Lokale Zeitverschiebung',
  'timezone.timeZone': 'Zeitzone',
  'timezone.today': 'Heute',
  'timezone.hours': 'Std',
  'timezone.standardTimeZone': 'Standard-Zeitzone',
  'timezone.daylightSavingTimeZone': 'Sommerzeit-Zeitzone',

  // City names (keeping English as standard)
  'city.newYork': 'New York',
  'city.london': 'London',
  'city.paris': 'Paris',
  'city.tokyo': 'Tokio',
  'city.sydney': 'Sydney',
  'city.dubai': 'Dubai',
  'city.singapore': 'Singapur',
  'city.hongKong': 'Hongkong',
  'city.shanghai': 'Shanghai',
  'city.beijing': 'Peking',
  'city.mumbai': 'Mumbai',
  'city.moscow': 'Moskau',
  'city.berlin': 'Berlin',
  'city.losAngeles': 'Los Angeles',
  'city.chicago': 'Chicago',
  'city.toronto': 'Toronto',
  'city.vancouver': 'Vancouver',
  'city.brasilia': 'Brasília',
  'city.buenosAires': 'Buenos Aires',
  'city.cairo': 'Kairo',
  'city.istanbul': 'Istanbul',

  // How to use
  'howto.title': 'So Verwenden Sie die Online-Weltzeituhr',
  'howto.step1': 'Diese Weltzeituhr-Website zeigt die aktuelle Zeit und Weltzeit für jede Stadt weltweit. Überprüfen Sie Zeitzonen, Weltzeitunterschiede und internationale Zeit sofort auf der ganzen Welt.',
  'howto.step2': 'Die Weltzeituhr-Startseite zeigt Ihre Ortszeit sowie mehrere Weltuhren für große Städte. Jede Weltzeitzone zeigt präzise Zeit-, Datums- und Zeitverschiebungsinformationen.',
  'howto.step3': 'Klicken Sie auf einen beliebigen Stadtnamen in der Weltzeituhr-Liste, um detaillierte Zeitzoneninformationen anzuzeigen. Jede Weltzeitseite bietet umfassende Zeitzonendaten und die aktuelle Zeit für diesen Standort.',
  'howto.step4': 'Verwenden Sie die Weltzeituhr-Suche, um die Zeit in jeder Stadt weltweit zu finden. Perfekt zum Überprüfen von Weltzeitzonen, internationaler Zeitkoordination und globalen Zeitmanagement-Anforderungen.',

  // User reviews
  'reviews.title': 'Nutzerbewertungen',
  'reviews.globalBusiness': 'Unverzichtbar für internationale Geschäfte! Einfache Koordination von Besprechungszeiten über verschiedene Zeitzonen hinweg, sehr praktisch.',
  'reviews.travelBlogger': 'Unverzichtbar für die Reiseplanung! Ich kenne immer die Ortszeit an meinem Zielort, keine Verwirrung mehr durch Jetlag.',
  'reviews.remoteTeam': 'Perfekt für die Remote-Team-Zusammenarbeit! Einfach zu sehen, wann Kollegen in verschiedenen Ländern arbeiten.',
  'reviews.internationalFamily': 'Großartig, um mit der Familie im Ausland in Verbindung zu bleiben! Ich weiß immer die beste Zeit zum Anrufen, ohne ihren Schlaf zu stören.',
  'reviews.managerZhang': 'Als Projektmanager hilft mir das, Besprechungen mit globalen Kunden effektiver zu planen.',

  // User names
  'user.globalBusiness': 'Globales Geschäft',
  'user.travelBlogger': 'Reise-Blogger',
  'user.remoteTeam': 'Remote-Entwickler',
  'user.internationalFamily': 'Internationale Familie',
  'user.managerZhang': 'Manager Zhang',

  // Keywords
  'keywords.worldclock': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'Zeit nach Land',
  'timeIn': 'Zeit in',
  'cities': 'Städte',
  'available': 'verfügbar',
  'citiesIn': 'Städte in',
  'viewDetails': 'Details anzeigen',
  'countryNotFound': 'Land nicht gefunden',
  'backToWorldClock': 'Zurück zur Weltzeituhr',
  'cityNotFound': 'Stadt nicht gefunden',
  'popularCitiesIn': 'Beliebte Städte in',
  'currentTime': 'Aktuelle Zeit',
};
